import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import * as graph from '@adc/sdk';
import Icon from '../elementals/icon';
import Text from '../elementals/text';
import MilestoneLabel from './MilestoneLabel';
import MilestoneDate from './MilestoneDate';
import MilestonAction from './milestonAction';
import styles from './styles.scss';
import { PopupTooltip } from '../overlays';
const cx = classnames.bind(styles);
const milestoneIconStyles = {
    [graph.enums.ShallowTaskWorkflowItemStatus.Complete]: {
        color: 'success',
        iconStyle: 'solid',
    },
    [graph.enums.ShallowTaskWorkflowItemStatus.Ongoing]: {
        color: 'success',
        iconStyle: 'regular',
    },
    [graph.enums.ShallowTaskWorkflowItemStatus.Upcoming]: {
        color: 'grayMediumLight',
        iconStyle: 'regular',
    },
};
const milestoneTextStyles = {
    [graph.enums.ShallowTaskWorkflowItemStatus.Complete]: { color: 'success' },
    [graph.enums.ShallowTaskWorkflowItemStatus.Ongoing]: { color: 'success' },
    [graph.enums.ShallowTaskWorkflowItemStatus.Upcoming]: { color: 'grayDark' },
};
const WorkflowDetails = ({ group, offerWorkflowStatus, closing, elmId = 'workflow_details', }) => {
    return (_jsxs("div", { className: cx('group-details'), children: [_jsxs("div", { className: cx('group-header', group.status.toLowerCase()), children: [_jsx(Icon, { name: 'check-circle', size: 'large', ...milestoneIconStyles[group.status] }), _jsx(Text, { size: 'large', weight: 'black', ...milestoneTextStyles[group.status], children: group.label })] }), _jsxs("div", { className: cx('milestones-list', {
                    complete: group.status === graph.enums.ShallowTaskWorkflowItemStatus.Complete,
                }), children: [group.description ? (_jsx("div", { className: cx('u-mb-3'), "data-elm-id": `${elmId}_group_description`, children: _jsxs(Text, { color: 'gray', size: 'tiny', children: [group.description, ' ', group.tooltip_label ? (_jsx(PopupTooltip, { hideOnScroll: true, trigger: _jsx(Icon, { name: 'info-circle', iconStyle: 'light', size: 'small' }), content: _jsx(Text, { size: 'tiny', color: 'white', children: group.tooltip_label }), position: 'top center', on: 'hover' })) : null] }) })) : null, group.tasks.map(task => (_jsxs("div", { className: cx('milestone'), children: [_jsx(Icon, { name: 'check-circle', size: 'large', ...(task.status && milestoneIconStyles[task.status]) }), _jsx(MilestoneLabel, { milestone: task, offerWorkflowStatus: offerWorkflowStatus }), _jsxs("div", { className: cx('milestone-date-action'), children: [_jsx(MilestoneDate, { milestone: task }), _jsx(MilestonAction, { milestone: task, closing: closing })] })] }, task.code)))] })] }));
};
export default WorkflowDetails;
//# sourceMappingURL=WorkflowDetails.js.map